module.exports = __webpack_public_path__ + "972227d5bb5c123e4f1c0a856765e9b2.svg";